import type { FC, ReactNode } from 'react';

import styled, { css } from 'styled-components';

const PlaceholderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  padding: ${({ theme }) => theme.space[4]}px 0;
`;

const PlaceholderText = styled.p(
  ({ theme: { colors, fontSizes, space } }) => css`
    margin: ${space[1]}px 0 0;
    font-size: ${fontSizes[5]}px;
    color: ${colors.text.secondary};
    text-align: center;
  `,
);

const PlaceholderIconWrapper = styled.div(
  ({ theme: { colors } }) => css`
    color: ${colors.text.disabled};
  `,
);

const DataIcon: FC = () => (
  <svg
    fill="none"
    height="48"
    viewBox="0 0 48 48"
    width="48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="currentColor" height="3" opacity="0.3" rx="1.5" width="24" x="12" y="14" />
    <rect fill="currentColor" height="3" opacity="0.3" rx="1.5" width="20" x="12" y="21" />
    <rect fill="currentColor" height="3" opacity="0.3" rx="1.5" width="16" x="12" y="28" />
    <path
      d="M8 10C8 8.89543 8.89543 8 10 8H38C39.1046 8 40 8.89543 40 10V38C40 39.1046 39.1046 40 38 40H10C8.89543 40 8 39.1046 8 38V10Z"
      opacity="0.15"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

interface PlaceholderProps {
  text?: ReactNode;
}

const Placeholder: FC<PlaceholderProps> = ({ text }) => (
  <PlaceholderContainer>
    <PlaceholderIconWrapper>
      <DataIcon />
    </PlaceholderIconWrapper>
    <PlaceholderText>{text ?? 'Нет записей.'}</PlaceholderText>
  </PlaceholderContainer>
);

export { Placeholder };
export type { PlaceholderProps };
